import { render, staticRenderFns } from "./ResourcesInternalOverview.vue?vue&type=template&id=b8e0de86&scoped=true&"
import script from "./ResourcesInternalOverview.vue?vue&type=script&lang=js&"
export * from "./ResourcesInternalOverview.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesInternalOverview.vue?vue&type=style&index=0&id=b8e0de86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e0de86",
  null
  
)

export default component.exports